import React, { useRef, useState, useEffect } from "react";

const Section2 = ({ url }) => {
  const sectionRef = useRef(null);
  const [Slick, setSlick] = useState(null);
  const slickLoaded = useRef(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      async (entries) => {
        const entry = entries[0];
        if (entry.isIntersecting && !slickLoaded.current) {
          slickLoaded.current = true;
          const slickModule = await import("react-slick");
          await import("slick-carousel/slick/slick.css");
          await import("slick-carousel/slick/slick-theme.css");
          setSlick(() => slickModule.default);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    speed: 600,
    responsive: [
      { breakpoint: 1200, settings: { slidesToShow: 2 } },
      { breakpoint: 768,  settings: { slidesToShow: 1 } },
    ],
  };

const cards = [
  {
    image: `${url}images/customDevelopment/sec3/1.png`,
    title: "Web Application Development",
    desc: "Build powerful, scalable web applications that handle your core business processes, from internal tools and client portals to full-scale SaaS platforms.",
    bullets: [
      "Replace manual workflows with purpose-built web applications",
      "Internal operations tools, client-facing portals, and SaaS platforms",
      "Scalable architecture designed to grow with your business from day one",
    ],
  },
  {
    image: `${url}images/customDevelopment/sec3/2.png`,
    title: "Mobile Application Development",
    desc: "iOS and Android applications built around your user journey and business logic, not templated app experiences that feel generic to your customers.",
    bullets: [
      "Cross-platform and native mobile applications built to your specifications",
      "User experience designed around your actual customer journey",
      "Integrated with your existing backend systems and data sources",
    ],
  },
  {
    image: `${url}images/customDevelopment/sec3/3.png`,
    title: "Legacy System Modernization",
    desc: "Your existing system does not have to be thrown away. We audit, restructure, and modernize legacy software so it performs at the level your business demands today.",
    bullets: [
      "Comprehensive audit of existing architecture before any code is rewritten",
      "Phased modernization that keeps your operations running during the transition",
      "Migration to modern stack without disrupting existing data or workflows",
    ],
  },
  {
    image: `${url}images/customDevelopment/sec3/4.png`,
    title: "API & System Integration",
    desc: "Connect your disconnected tools and data sources into a unified ecosystem. Stop toggling between platforms and start operating from a single source of truth.",
    bullets: [
      "Third-party API integration across your existing software stack",
      "Custom middleware and data pipeline development",
      "Unified data layer that eliminates duplicate entry and synchronization errors",
    ],
  },
];

  return (
    <section className="home-section-3 overflow-hidden" ref={sectionRef}>
      <div className="container overflow-hidden">

        <h2 className="s3-title" data-aos="fade-up">
          Custom Software Development Services Built Around Your Operations
        </h2>

        <p className="s3-subtitle" data-aos="fade-up" data-aos-delay="100">
          ExD Digital designs and develops software from the ground up, built specifically 
          for how your business works, not how a software vendor thinks it should work. 
          Every line of code serves a purpose tied directly to your operational outcome.
        </p>

            {/* Slider — full width */}
            <div className="s3-slider-wrapper" data-aos="fade-up" data-aos-delay="200">
                {Slick ? (
                <Slick {...settings}>
                    {cards.map((card, idx) => (
                    <div className="s3-slide-pad" key={idx}>
                        <div className="s3-card">
                        <div className="s3-card-image">
                            <img src={card.image} alt={card.title} />
                        </div>
                        <div className="s3-card-body">
                            <h3 className="s3-card-title">{card.title}</h3>
                            <p className="s3-card-desc">{card.desc}</p>
                            <ul className="s3-card-bullets">
                            {card.bullets.map((b, i) => (
                                <li key={i}>{b}</li>
                            ))}
                            </ul>
                        </div>
                        </div>
                    </div>
                    ))}
                </Slick>
                ) : (
                // skeleton placeholders while slick loads
                <div className="s3-skeleton-row">
                    {[1, 2, 3].map((i) => (
                    <div className="s3-skeleton-card" key={i} />
                    ))}
                </div>
                )}
            </div>
        </div>
    </section>
  );
};

export default Section2;